import React, {useState, useEffect} from "react";
import EmployeesList from "./EmployeesList";
import EmployeeEditor from "./EmployeeEditor";
import Notification from "../Common/Notification";

const EmployeesSettings = () => {
    const [searchTerm, setSearchTerm] = useState('');
    const [debouncedSearchTerm, setDebouncedSearchTerm] = useState('');
    const [selectedItems, setSelectedItems] = useState([]);
    const [selectedAll, setSelectedAll] = useState(false);
    const [showEditor, setShowEditor] = useState(false);
    const [currentEmployee, setCurrentEmployee] = useState(null);
    const [notification, setNotification] = useState({
        show: false,
        type: 'success',
        message: '',
    });


    // Debounce search term
    useEffect(() => {
        const timer = setTimeout(() => {
            setDebouncedSearchTerm(searchTerm);
        }, 300);

        return () => clearTimeout(timer);
    }, [searchTerm]);

    // Function to show a notification
    const showNotification = (type, message) => {
        setNotification({
            show: true,
            type,
            message,
        });

        // Auto hide after 5 seconds for success notifications
        if (type === 'success') {
            setTimeout(() => {
                setNotification(prev => ({...prev, show: false}));
            }, 5000);
        }
    };

    // Function to hide notification
    const hideNotification = () => {
        setNotification(prev => ({...prev, show: false}));
    };

    // Handle create new employee
    const handleCreateEmployee = () => {
        setCurrentEmployee(null);
        setShowEditor(true);
    };

    // Handle edit employee
    const handleEditEmployee = (employee) => {
        setCurrentEmployee(employee);
        setShowEditor(true);
    };

    // Handle back from editor
    const handleCloseEditor = () => {
        setShowEditor(false);
        setCurrentEmployee(null);
    };

    return (
        <div>
            <EmployeesList
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
                debouncedSearchTerm={debouncedSearchTerm}
                selectedItems={selectedItems}
                setSelectedItems={setSelectedItems}
                selectedAll={selectedAll}
                setSelectedAll={setSelectedAll}
                showNotification={showNotification}
                onCreateEmployee={handleCreateEmployee}
                onEditEmployee={handleEditEmployee}
            />

            {showEditor && (
                <EmployeeEditor
                    employee={currentEmployee}
                    onClose={handleCloseEditor}
                    showNotification={showNotification}
                />
            )}

            {/* Notification */}
            {notification.show && (
                <Notification
                    type={notification.type}
                    message={notification.message}
                    onClose={hideNotification}
                />
            )}
        </div>
    );
};

export default EmployeesSettings;
